function TextureSwatch({ texture, selected, onClick }) {
  return (
    <div className="flex flex-col items-center gap-1">
      <button
        onClick={onClick}
        title={texture.label}
        className={`aspect-square w-full overflow-hidden border-2 transition-all ${
          selected
            ? "border-gray-900 scale-95"
            : "border-transparent hover:border-gray-300"
        }`}
      >
        <img
          src={texture.thumbnail ?? texture.path}
          alt={texture.label}
          className="w-full h-full object-cover"
        />
      </button>
      <span className="text-[11px] text-gray-500 text-center leading-tight line-clamp-2 w-full">
        {texture.label}
      </span>
    </div>
  );
}

export default function TextureGrid({
  textures,
  selectedId,
  onSelect,
  cols = 5,
}) {
  const gridClass =
    { 4: "grid-cols-4", 5: "grid-cols-5" }[cols] ?? "grid-cols-5";

  return (
    <div className={`grid ${gridClass} gap-1.5 p-5`}>
      {textures.map((tex) => (
        <TextureSwatch
          key={tex.id}
          texture={tex}
          selected={selectedId === tex.id}
          onClick={() => onSelect(tex)}
        />
      ))}
    </div>
  );
}
